import { ALL_CONTACTS_SEGMENT } from '@/services/constants';
import { CampaignRecipient } from '@dev/ee-api/ee-api-models';
import { isAllContactsOptionSelected } from '../../helpers';
import { OptionProps, AutocompleteCategories } from '../SendToInterface';

export const convertToCampaignRecipient = (chosenOptions: OptionProps[]): CampaignRecipient => {
    const isAllContactsSelected = isAllContactsOptionSelected(chosenOptions);
    return chosenOptions.reduce(
        (val: CampaignRecipient, current) => {
            if (current.category === AutocompleteCategories.List) {
                return {
                    ListNames: [...val.ListNames, current.label],
                    SegmentNames: val.SegmentNames,
                };
            }
            return {
                ListNames: val.ListNames,
                SegmentNames: isAllContactsSelected ? [ALL_CONTACTS_SEGMENT] : [...val.SegmentNames, current.label],
            };
        },
        {
            ListNames: [],
            SegmentNames: [],
        }
    );
};
